'use client';

import {useEffect} from 'react';
import useToast from '@purpose/ui/hooks/useToast';
import {toastManager} from '#lib/toast-manager';

interface ToastProviderProps {
  children: React.ReactNode;
  locale: string;
}

export default function ToastProvider({locale, children}: ToastProviderProps) {
  const {toast} = useToast(locale);

  useEffect(() => {
    // Register the toast function with the global toast manager
    toastManager.registerToastFunction(toast);

    // Cleanup on unmount
    return () => {
      toastManager.registerToastFunction(() => {});
    };
  }, [toast]);

  return <>{children}</>;
}
